<button
  appIconButton
  color="secondary"
  [disabled]="!hasActiveItems()"
  (click)="toggle($event)"
>
  <svg appIcon="dots" />
</button>

<app-menu
  #menu
  appendTo="body"
  styleClass="table-row-actions-panel"
  [items]="resolvedActions()"
/>
